import { FC } from "react";
import { useStyles } from "./CaLoading.style";
import LogoIcon from "../../../assets/image/logo_1x.webp";
import LogoIcon2x from "../../../assets/image/logo_2x.webp";
import LogoIcon3x from "../../../assets/image/logo_3x.webp";
import {
  Image,
  Typography,
  TypographyVariant,
  ProgressIndicator,
} from "@onmo/ui";
import { useAppSelector } from "../../../hooks";
import { getImage3x } from "../../../models/theme";
import { useTranslation } from "react-i18next";

export const CaLoading: FC = () => {
  const classes = useStyles();
  const { theme } = useAppSelector((state) => state.theme);
  const logoImage = getImage3x("splash-logo.webp");
  const { t } = useTranslation();

  return (
    <div id="loading" className={classes.loaderWrapper}>
      <div className={classes.mainLogo}>
        <Image
          src={logoImage?.oneX || LogoIcon}
          src2x={logoImage?.twoX || LogoIcon2x}
          src3x={logoImage?.threeX || LogoIcon3x}
          alt="CA-logo-loading"
          className={classes.logo}
        />
      </div>
      {theme?.splash?.hasLoadingBar && (
        <div className={classes.content}>
          <Typography variant={TypographyVariant.HeadingH7Bold}>
            {t("play_compete_win")}
          </Typography>
          <Typography
            variant={TypographyVariant.BodyB6Regular}
            className={classes.titleLoad}
          >
            {t("loading_")}
          </Typography>
          <ProgressIndicator
            value={{
              initial: 0,
              target: 100,
              total: 100,
            }}
            color={theme.colors.primary}
            size="large"
            underBackground="primary"
          />
        </div>
      )}
    </div>
  );
};
